module.exports = __webpack_public_path__ + "static/img/constellation_gradient.a6da350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/plants/constellation_gradient.jpg
// module id = vq/y
// module chunks = 1